import { LoanForm } from './LoanForm';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { DISPOSITIONSKREDIT, type DISPOSITIONSKREDIT_TYPE } from '../../../types';
import { headers } from '../../constants';
import LoanCard from '../shared/LoanCard';

type Props = {
    credit: SchemaCreditRequestForm[DISPOSITIONSKREDIT_TYPE][number];
    index: number;
};

export const DetailedView = ({ credit, index }: Props) => (
    <td colSpan={headers.length} className="p-3">
        <LoanCard name={`${DISPOSITIONSKREDIT}.${index}`} credit={credit}>
            <LoanForm index={index} applicant={credit.gehoertZuAntragsteller} />
        </LoanCard>
    </td>
);
